import * as React from "react";

function SvgIcEmail(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 5a3 3 0 00-3 3v8a3 3 0 003 3h12a3 3 0 003-3V8a3 3 0 00-3-3H6zM5 8.06V16a1 1 0 001 1h12a1 1 0 001-1V8.06l-4.348 4.349a3.75 3.75 0 01-5.304 0L5 8.061zM17.94 7H6.06l4.349 4.348a2.25 2.25 0 003.182 0L17.939 7z"
        fill="currentColor"
      />
    </svg>
  );
}

export default SvgIcEmail;
